var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotEqual = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "not equal",
  d: "M1.5 8.61h3.68l1.63-3.22H1.5V3.5h6.27L9.35.35l1.59.87L9.78 3.5h2.72v1.89H8.82L7.19 8.61h5.31v1.89H6.23l-1.58 3.15-1.59-.87 1.16-2.28H1.5Z"
})));
export default SvgNotEqual;